
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/moje-konto/port-out/anuluj-przeniesienie",
      function () {
        return require("private-next-pages/moje-konto/port-out/anuluj-przeniesienie.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/moje-konto/port-out/anuluj-przeniesienie"])
      });
    }
  